import { createSelector } from 'reselect';

const organizations = state => state.auth.organizations;

export const selectOrganizationForDevice = organizationId => createSelector(
    [organizations],
    organizations => organizations.find(org => org.id === organizationId)
);
